// src/data/camisas.js
import athleticoPR from "./brasileirao/athletico-pr";
import atleticoMG from "./brasileirao/atletico-mg";
import bahia from "./brasileirao/bahia";
import botafogo from "./brasileirao/botafogo";
import coritiba from "./brasileirao/coritiba";
import bragantino from "./brasileirao/bragantino";
import corinthians from "./brasileirao/corinthians";
import remo from "./brasileirao/remo";
import cruzeiro from "./brasileirao/cruzeiro";
import vasco from "./brasileirao/vasco";
import vitoria from "./brasileirao/vitoria";
import saopaulo from "./brasileirao/saopaulo";
import santos from "./brasileirao/santos";
import palmeiras from "./brasileirao/palmeiras";
import internacional from "./brasileirao/internacional";
import gremio from "./brasileirao/gremio";
import fluminense from "./brasileirao/fluminense";
import flamengo from "./brasileirao/flamengo";
import brasil from "./selecaoBrasileira/brasil";

//Premier League
import arsenal from "./premierLeague/arsenal";
import astonVilla from "./premierLeague/aston-villa";
import bournemouth from "./premierLeague/bournemouth";
import brentford from "./premierLeague/brentford";
import brighton from "./premierLeague/brighton";
import burnley from "./premierLeague/burnley";
import chelsea from "./premierLeague/chelsea";

// Europa
import mu from "./europa/mu";
import city from "./europa/mcity";
import tottenham from "./europa/tottenham";
import liverpool from "./europa/liverpool";
import bvb from "./europa/bvb";
import bayerm from "./europa/bayerm";
import psg from "./europa/psg";
import barcelona from "./europa/barcelona";
import realmadrid from "./europa/realmadrid";
import interdemilao from "./europa/interdemilao";
import milan from "./europa/milan";
import juventus from "./europa/juventus";
import copa from "./wc26/copa";

const camisas = [
  ...athleticoPR,
  ...atleticoMG,
  ...bahia,
  ...botafogo,
  ...bragantino,
  ...corinthians,
  ...coritiba,
  ...cruzeiro,
  ...flamengo,
  ...fluminense,
  ...gremio,
  ...internacional,
  ...palmeiras,
  ...remo,
  ...santos,
  ...saopaulo,
  ...vasco,
  ...vitoria,
  ...brasil,
  ...copa,

  //premier league
  ...arsenal,
  ...astonVilla,
  ...bournemouth,
  ...brentford,
  ...brighton,
  ...burnley,
  ...chelsea,

  //europa
  ...barcelona,
  ...bayerm,
  ...bvb,
  ...juventus,
  ...liverpool,
  ...interdemilao,
  ...milan,
  ...city,
  ...mu,
  ...psg,
  ...realmadrid,
  ...tottenham,
];

export default camisas;
